module.exports = __webpack_public_path__ + "img/loading.16dbfed7.png";